import React, { useState } from "react";
import SubCont from "@mui/material/Box";
import logo from "../images/logoNew.png";

import Container from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import LoginImg from "../images/loginDoctorImage.webp";
import TextField from "@mui/material/TextField";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setPatientDetails } from "../reduxtool/action";
import axios from "axios";
import { encryptData } from "../Services/TabServices";
import { IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 5%;
`;
const Heading = styled.div`
  color: black;
  font-size: 30px;
  font-weight: 600;
  padding: 10px;
`;
const SubHeading = styled.div`
  color: #313131;
  font-size: 16px;
  font-weight: 400;
  padding: 5px 10px;
`;

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: window.innerWidth < 480 ? "85%" : "60%",
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  p: 1,
};

const CrmLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const { executeRecaptcha } = useGoogleReCaptcha();

  const [errorMessage, setErrorMessage] = useState("");
  const [openForm, setOpenForm] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async () => {
     if (!executeRecaptcha) {
      // Toast.error('reCAPTCHA not ready. Please try again.');
      setLoading(false);
      return;
    }

    const recaptchaToken = await executeRecaptcha('callback_request');

    if (!recaptchaToken) {
      // setMessage('Captcha verification failed. Please try again.');
      setLoading(false);
      return;
    }
      const payload = {
    ...formData,
    recaptchaToken: recaptchaToken,
  };
    try {
      setLoading(true);
      setErrorMessage("");
      const response: any = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/User/AdminCrmLogin`,
        payload
      );
      // const userId= response.data.userId
      const userId = response.data.userId?.toString();
      const encryptedUserId = encryptData(userId);
      sessionStorage.setItem("userId", encryptedUserId);

      const userType = response.data.itemFlag;
      const token = response.data.token;
      sessionStorage.setItem("userId", encryptedUserId);
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("userType", userType);
      setLoading(false);
      navigate("/CRMDashboard");
    } catch (error: any) {
      console.error("error in Crm Login", error);
      setErrorMessage(
        error?.message === "Network Error"
          ? "Network error. Please check your connection and try again."
          : "Something went wrong. Please try again."
      );
      setLoading(false);
    }
  };
  return (
    <Container
      open={openForm}
      aria-labelledby="modal-modal-title"
      onClick={() => navigate("/crmLogin")}
    >
      <div>
        {/* Mobile View - Enhanced UI without Image */}
        <div
          className="block md:hidden absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl w-[92%] max-h-[85vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Mobile Close Button */}
          {/* <CloseIcon 
          onClick={() => navigate("/crmLogin")} 
          className="float-right m-4 p-2 cursor-pointer rounded-full hover:bg-gray-100 transition-all duration-200"
        /> */}

          {/* Mobile Content Container */}
          <div className="px-6 py-8 pt-8">
            <div className="text-center space-y-6">
              {/* Mobile Login Header */}
              <div className="space-y-3">
                <div className=" w-full max-w-[150px]   flex items-center justify-center mx-auto mb-3">
                  <img src={logo} alt="" className="" />
                </div>
                <h1 className="text-2xl font-bold text-gray-900"> CRM Login</h1>
                <p className="text-gray-600 text-sm leading-relaxed px-2">
                  Login to access your account
                </p>
              </div>

              {/* Mobile Login Form */}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleLogin();
                }}
                className="space-y-5"
              >
                <div className="space-y-4 text-left">
                  <TextField
                    required
                    label="Username"
                    name="username"
                    value={formData.username}
                    fullWidth
                    size="small"
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "52px",
                        borderRadius: "16px",
                        fontSize: "16px",
                      },
                    }}
                  />

                  <TextField
                    required
                    label="Password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    fullWidth
                    size="small"
                    onChange={handleChange}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "52px",
                        borderRadius: "16px",
                        fontSize: "16px",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge="end"
                            size="small"
                            sx={{
                              p: 0.5,
                              "& svg": { fontSize: "1rem" },
                            }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-3">
                    <div className="flex items-start space-x-2">
                      <svg
                        className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      <p className="text-blue-700 text-xs leading-relaxed">
                        Your credentials are securely encrypted and protected.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Mobile Error Message */}
                {errorMessage && (
                  <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg text-left">
                    <p className="text-red-700 text-sm font-medium">
                      {errorMessage}
                    </p>
                  </div>
                )}

                {/* Mobile Submit Button */}
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`w-full py-4 rounded-2xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                    isLoading
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                  }`}
                >
                  {isLoading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <svg
                        className="w-5 h-5 animate-spin"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v8H4z"
                        />
                      </svg>
                      <span>Logging in...</span>
                    </div>
                  ) : (
                    "Log In"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Desktop View - Enhanced UI with Image on Left */}
        <div
          className="hidden sm:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl rounded-2xl outline-none  w-[90%] md:w-[80%] lg:w-auto 2xl:w-[900px]  max-h-[80vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Desktop Close Button */}
          <CloseIcon
            // onClick={() => navigate("/crmLogin")}
            className="float-right  p-1 rounded-full text-white"
          />

          {/* Desktop Container with Image and Content */}
          <div className="flex flex-row justify-between items-center gap-8 ">
            {/* Image Section - Left Side */}
            <div className="flex items-center justify-center w-1/2">
              <div className="w-full max-w-sm">
                <img
                  src={LoginImg}
                  alt="Login"
                  className="w-full h-auto object-contain rounded-lg shadow-md"
                />
              </div>
            </div>

            {/* Content Section - Right Side (Mobile UI Style) */}
            <div className="w-1/2">
              <div className="text-center space-y-6">
                {/* Desktop Header */}
                <div className="space-y-3">
                  <h1 className="text-2xl font-bold text-gray-900">
                    CRM Login
                  </h1>
                  <p className="text-gray-600 text-sm leading-relaxed px-2">
                    Login to access your account
                  </p>
                </div>

                {/* Desktop Login Form */}
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleLogin();
                  }}
                  className="space-y-5"
                >
                  <div className="space-y-4 text-left">
                    <TextField
                      required
                      label="Username"
                      name="username"
                      value={formData.username}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "48px",
                          borderRadius: "12px",
                          fontSize: "16px",
                        },
                      }}
                    />

                    <TextField
                      required
                      label="Password"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={formData.password}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "48px",
                          borderRadius: "12px",
                          fontSize: "16px",
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setShowPassword((prev) => !prev)}
                              edge="end"
                              size="small"
                              sx={{
                                p: 0.5,
                                "& svg": { fontSize: "1rem" },
                              }}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />

                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-3">
                      <div className="flex items-start space-x-2">
                        <svg
                          className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <p className="text-blue-700 text-xs leading-relaxed">
                          Your credentials are securely encrypted and protected.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Desktop Error Message */}
                  {errorMessage && (
                    <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-lg text-left">
                      <p className="text-red-700 text-sm font-medium">
                        {errorMessage}
                      </p>
                    </div>
                  )}

                  {/* Desktop Submit Button */}
                  <button
                    type="submit"
                    disabled={isLoading}
                    className={`w-full py-3 rounded-xl text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                      isLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                    }`}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center space-x-2">
                        <svg
                          className="w-5 h-5 animate-spin"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8H4z"
                          />
                        </svg>
                        <span>Logging in...</span>
                      </div>
                    ) : (
                      "Log In"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CrmLogin;
